import { RotateCw, WifiOff } from 'lucide-react'
import { useState } from 'react'

interface ErreurChargementProps {
  message: string
  onReessayer: () => Promise<void>
}

export default function ErreurChargement({ message, onReessayer }: ErreurChargementProps) {
  const [enCours, setEnCours] = useState(false)

  const reessayer = async () => {
    setEnCours(true)
    await onReessayer()
    setEnCours(false)
  }

  return (
    <div role="alert" className="text-center py-12 px-4">
      <WifiOff size={28} className="mx-auto text-cmp-navy/30" />
      <p className="text-cmp-navy font-bold mt-3">Impossible de charger les prédications</p>
      <p className="text-gray-500 text-sm mt-1">{message}</p>
      <button
        type="button"
        onClick={reessayer}
        disabled={enCours}
        className="mt-5 inline-flex items-center gap-2 border border-cmp-navy/20 text-cmp-navy rounded-full py-2.5 px-5 text-sm font-semibold hover:bg-cmp-sky-light transition-colors active:scale-95 disabled:opacity-60"
      >
        <RotateCw size={14} className={enCours ? 'animate-spin' : ''} />
        Réessayer
      </button>
    </div>
  )
}
